import React from 'react';
import {useSelector} from "react-redux";
import {bbFindEntityWithinPortfolioOrSelf} from "../../util/bbHelpers";
import BBExternalLink from "../../components/customBreachBits/accents/BBExternalLink";



export const BRBizInitialTourCloudIntegrations ={
    url: `/board/BreachRisk/Business/CloudIntegration`,
    type: `tutorial`,
    user: {
        first_login: true,
    },
    entity: {
        verified_ownership: true,
        hasScores: null,
    },
    openingModal: null,
    //     {
    //     icon: null,
    //     heading: "Using the Cloud? So Are We.",
    //     description: <div className={"text-center mx-2 px-2"}>
    //         <p>
    //             Integrating your cloud-based infrastructure is the easiest and fastest way to keep your verifications updated.
    //         </p>
    //         <p>
    //             Click "Start Tour" to learn more about what you'll need to set up these integrations before getting started.
    //         </p>
    //     </div>
    // },
    tourSteps:{
        1:{
            step: 1,
            title: "Using the Cloud? So Are We.",
            content: <div className={"text-center mx-2 px-2"}>
                <p>
                    Integrating your cloud-based infrastructure is the easiest and fastest way to keep your verifications updated.
                </p>
            </div>,
            scrollToElement: false,
            anchorEl: "#tourCloudIntegration",
            placement: "top-start",
            element: null,
            last: false,
        },
        2:{
            step: 2,
            title: null,
            content: "Click on the service you're looking to integrate for step by step directions.",
            scrollToElement: false,
            anchorEl: "#tourCloudIntegration",
            placement: "top-center",
            element: null,
            last: false,
        },
        3:{
            step: 3,
            title: null,
            content: <p>Or find more about integrations in our <BBExternalLink href={"https://support.breachbits.com/knowledge/user-guides#integrations"}>Knowledge Base. </BBExternalLink></p>,
            scrollToElement: false,
            anchorEl: "#tourCloudIntegration",
            placement: "top-end",
            element: null,
            last: false,
        },
        4:{
            step: 4,
            placement: "top-start",
            title: "Resources Accessible to Cloud Integrations",
            content: `See what resources we've found in your cloud integrations.\n Tables display information about individual resources. \n`,
            scrollToElement: "#tourCloudDataHeader",
            anchorEl: "#tourBRCloudAppsChart",
            element: null,
            last: true,
        },
        // 5:{
        //     step: 5,
        //     placement: "left",
        //     title: "Resources Accessible to Cloud Integrations",
        //     content: "",
        //     scrollToElement: null,
        //     anchorEl: "#tourCloudDataHeader",
        //     element: null,
        //     last: false,
        // },
    },
    style: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        // width: 400,
        // height: 250,
        background: 'white',
        borderRadius: "10px",
        // border: '1px solid #000',
        boxShadow: 24,
        p: 4,
        // zIndex: 1502,
    }
}